const subCategoryType = {
    ADD_SUBCATEGORY: "ADD_SUBCATEGORY",
    RESET_SUBCATEGORY: "RESET_SUBCATEGORY",
};

export default subCategoryType;